import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  BasicInfoSliderInterface,
  signUpBasicInfoInitialValues,
} from '../../models/auth/signUp/signUpBasicInfo.model';
import {
  MoreInfoSliderInterface,
  signUpMoreInfoInitialValues,
} from '../../models/auth/signUp/signUpMoreInfo.model';
import {
  OptionsSliderInterface,
  signUpOptionsInitialValues,
} from '../../models/auth/signUp/signUpOptions.model';
import {
  PasswordSliderInterface,
  signUpPasswordInitialValues,
} from '../../models/auth/signUp/signUpPassword.model';

interface IInitialState {
  sliderIndex: number;
  basicInfoSlider: BasicInfoSliderInterface;
  moreInfoSlider: MoreInfoSliderInterface;
  optionsSlider: OptionsSliderInterface;
  passwordSlider: PasswordSliderInterface;
}
const initialState: IInitialState = {
  sliderIndex: 0,
  basicInfoSlider: signUpBasicInfoInitialValues,
  moreInfoSlider: signUpMoreInfoInitialValues,
  optionsSlider: signUpOptionsInitialValues,
  passwordSlider: signUpPasswordInitialValues,
};

const sigUpSlice = createSlice({
  name: 'signUpSliders',
  initialState,
  reducers: {
    setSliderIndex(state, action: PayloadAction<number>) {
      state.sliderIndex += action.payload;
    },
    setBasicInfoSlider(state, action: PayloadAction<BasicInfoSliderInterface>) {
      state.basicInfoSlider = action.payload;
    },
    setMoreInfoSlider(state, action: PayloadAction<MoreInfoSliderInterface>) {
      state.moreInfoSlider = action.payload;
    },
    setOptionsSlider(state, action: PayloadAction<OptionsSliderInterface>) {
      state.optionsSlider = action.payload;
    },
    setPasswordSlider(state, action: PayloadAction<PasswordSliderInterface>) {
      state.passwordSlider = action.payload;
    },
    reset: () => initialState,
  },
});

export const signUpActions = sigUpSlice.actions;
export default sigUpSlice.reducer;
